import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getObligationEstablishmentList as getObligationEstablishmentListApi,
	getObligationEstablishment as getObligationEstablishmentApi,
	addNewObligationEstablishment as addNewObligationEstablishmentApi,
	updateObligationEstablishment as updateObligationEstablishmentApi,
	deleteObligationEstablishment as deleteObligationEstablishmentApi,
	ObligationEstablishmentUpdate as ObligationEstablishmentUpdateApi,
	fetchCriticalityList as fetchCriticalityListApi,
	fetchComplianceList as fetchComplianceListApi,
	fetchComplianceMatrix as fetchComplianceMatrixApi
} from '../../helpers/normative/backend_helper';

export const getObligationEstablishmentList = createAsyncThunk('obligationEstablishments/getObligationEstablishmentList', async () => {
	try {
		const response = getObligationEstablishmentListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getObligationEstablishment = createAsyncThunk('obligationEstablishments/getObligationEstablishment', async obligationEstablishment_id => {
	try {
		const response = getObligationEstablishmentApi(obligationEstablishment_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewObligationEstablishment = createAsyncThunk('obligationEstablishments/addNewObligationEstablishment', async obligationEstablishment => {
	try {
		const response = addNewObligationEstablishmentApi(obligationEstablishment);
		toast.success('ObligationEstablishment agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar obligationEstablishment.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateObligationEstablishment = createAsyncThunk('obligationEstablishments/updateObligationEstablishment', async (obligationEstablishment) => {
	try {
		const response = updateObligationEstablishmentApi(obligationEstablishment);
		toast.success('ObligationEstablishment actualizado exitosamente', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al actualizar obligationEstablishment.', { autoClose: 3000 });
		throw new Error(error);
	}
}
);

export const deleteObligationEstablishment = createAsyncThunk('obligationEstablishments/deleteObligationEstablishment', async obligationEstablishment => {
	try {
		const response = await deleteObligationEstablishmentApi(obligationEstablishment);
		toast.success('ObligationEstablishment eliminado exitosamente.', { autoClose: 3000 });
		return { obligationEstablishment, ...response };
	} catch (error) {
		toast.error('Error al eliminar obligationEstablishment.', { autoClose: 3000 });
		throw new Error(error);
	}
});



export const ObligationEstablishmentUpdate = createAsyncThunk('obligationEstablishments/ObligationEstablishmentUpdate', async obligationEstablishment_id => {
	try {
		const response = ObligationEstablishmentUpdateApi(obligationEstablishment_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});


export const fetchCriticalityList = createAsyncThunk('obligationEstablishments/fetchCriticalityList', async (params) => {
	try {
		const response = fetchCriticalityListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const fetchComplianceList = createAsyncThunk('obligationEstablishments/fetchComplianceList', async (params) => {
	try {
		const response = fetchComplianceListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const fetchComplianceMatrix = createAsyncThunk('obligationEstablishments/fetchComplianceMatrix', async (params) => {
	try {
		const response = fetchComplianceMatrixApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});
